import React, { useEffect, useState } from 'react';
import axios from 'axios';

const FileTable = ({ userId }) => {
  const [files, setFiles] = useState([]);

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASEURL}/images`, {
          params: { 
            // UserID: userId
            UserID: '2403000005' // Replace 'yourUserId' with the actual user ID you want to pass
        
        }
        });
        setFiles(response.data);
      } catch (error) {
        console.error('Error fetching files:', error);
      }
    };

    fetchFiles();
  }, [userId]);

  const handleFileClick = (file) => {
    const link = document.createElement('a');
    link.href = `data:${file.mimeType};base64,${file.base64Image}`;
    link.download = file.filename;
    link.target = '_blank';
    link.click();
  };

  return (
    <div>
      <h2>Files</h2>
      <table>
        <thead>
          <tr>
            <th>Filename</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {files.map((file, index) => (
            <tr key={index}>
              <td>{file.filename}</td>
              <td>
                <button onClick={() => handleFileClick(file)}>
                  Open
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FileTable;
